var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-field-wrapper',_vm._b({staticClass:"eaasi-text-input",attrs:{"readonly":_vm.readonly,"required":_vm.required}},'form-field-wrapper',_vm.wrapperProps,false),[_c('div',{staticClass:"eaasi-input-wrapper"},[_c('div',{class:[
				'eaasi-input flex-row',
				_vm.fieldStatus,
				{ readonly: _vm.readonly }
			]},[_c('input',_vm._g(_vm._b({attrs:{"id":_vm.id},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.inputListeners)),_c('span',{staticClass:"eaasi-field-icon"},[_c('span',{class:("fas fa-" + _vm.icon)})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }